export const SET_READ_ONLY = 'SET_READ_ONLY';
export const REQUEST_ENVIRONMENTS = 'REQUEST_ENVIRONMENTS';
export const RECEIVE_ENVIRONMENTS = 'RECEIVE_ENVIRONMENTS';
export const REQUEST_ENVIRONMENTS_COMPLETE = 'REQUEST_ENVIRONMENTS_COMPLETE';
export const REQUEST_ENVIRONMENTS_FAILED = 'REQUEST_ENVIRONMENTS_FAILED';
export const REQUEST_SAVE_ENVIRONMENTS = 'REQUEST_SAVE_ENVIRONMENTS';
export const RECEIVE_SAVE_RESULT = 'RECEIVE_SAVE_RESULT';
export const SAVE_COMPLETE = 'SAVE_COMPLETE';
export const SAVE_FAILED = 'SAVE_FAILED';
